
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos/official-product-backlog-management-certification-training",
      function () {
        return require("private-next-pages/entrenamientos/official-product-backlog-management-certification-training.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entrenamientos/official-product-backlog-management-certification-training"])
      });
    }
  